'use client';
import { useEffect } from 'react';
import { fireFloodlightPixel } from '@/lib/floodlight';

// Fires a Floodlight page-load pixel once when the page component mounts.
export function useFloodlightPageview(sendTo: string) {
  useEffect(() => {
    fireFloodlightPixel(sendTo);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
}
